import { SelectItem } from 'primeng/api';
import { EligibilitySeverityType } from '../enums/eligibility-severity-type';

export class EligibilitySeverityTypeLookup {
    static getLookup(): SelectItem[] {
        return [
            { label: 'Fatal', value: EligibilitySeverityType.Fatal },
            { label: 'Error', value: EligibilitySeverityType.Error },
            { label: 'Warning', value: EligibilitySeverityType.Warning },
            { label: 'Information', value: EligibilitySeverityType.Information }];
    }

    static getTitleById(id) {
        return this.getLookup().find(f => f.value === id)?.label || '';
    }
}
